import { tracking } from '@iwoca/frontend-tracking-library';
import classNames from 'classnames';

import styles from './SpillBanner.module.css';
import { CloseSVG } from '../../svgComponents/closeSVG/CloseSVG';
import HeartSVG from '../../svgComponents/heartSVG/index';

interface SpillBannerProps {
    onClose: () => void;
    className?: string;
    legacy?: boolean;
}

export const SpillBanner = ({
    onClose,
    className,
    legacy
}: SpillBannerProps) => {
    return (
        <div
            role="banner"
            className={classNames(
                legacy ? styles.BannerLegacy : styles.Banner,
                className
            )}
        >
            <div
                className={
                    legacy ? styles.bannerContentLegacy : styles.bannerContent
                }
            >
                <HeartSVG
                    className={
                        legacy ? styles.heartIconLegacy : styles.heartIcon
                    }
                />
                <p
                    className={
                        legacy ? styles.bannerTextLegacy : styles.bannerText
                    }
                >
                    We've partnered with mental health platform Spill. You can
                    claim a free therapy session by clicking{' '}
                    <a
                        href="https://share.hsforms.com/1PpBUXKueSfOc3DkIkgp-1A51s0v"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.link}
                        onClick={() => tracking.ampli.spillBannerLinkClicked()}
                    >
                        here
                    </a>{' '}
                    (it's totally confidential and we won't see if you use it)
                </p>
            </div>

            <button
                aria-label="close-spill-banner"
                className={legacy ? styles.closeIconLegacy : styles.closeIcon}
                onClick={onClose}
            >
                <CloseSVG />
            </button>
        </div>
    );
};
